import { SET_INCENTIVE } from '../actions/types';

const initialState = {
	incentiveData: [
		{
			key: '',
			title: '',
			shortTitle: '',
			label: '',
			offerDetails: '',
			effectiveDate: '',
			expirationDate: '',
			conditional: false,
			disclaimer: '',
			make: '',
			condition: '',
			manufacturerOffer: false,
			specific: {},
			error: ''
		}
	]
};

export default function incentive(state = initialState, action) {
	if (!action.error) {
		switch (action.type) {
			case SET_INCENTIVE:
				return {
					...state,
					incentiveData: [...state.incentiveData, ...action.payload]
				};

			default:
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/incentive.js